import { MOBILE_WIDTH } from '../constants/breakpoints';

export const isMobile = (width, maxWidth = undefined) => {
  return maxWidth ? width <= maxWidth : width <= MOBILE_WIDTH;
};
